// Persist the client's optional "confirmation receipt" email across visits
// (Phase B3 Send modal field) — same pattern as clientName.ts. Purely a
// browser-side convenience; the value is never required and the server
// never stores it beyond sending that one receipt.

const KEY = 'hsp_client_receipt_email';

export function getStoredReceiptEmail(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function setStoredReceiptEmail(email: string): void {
  try {
    localStorage.setItem(KEY, email);
  } catch {}
}
